import { Box, useLayoutContext , Image as Img } from "arkh";
import { Image_image$key } from "arkh/src/cross-platform/__generated__/Image_image.graphql";
import { useCallback } from "react";
import { Image } from "expo-image";

export const TodoListItemImages = (props: {
  images: (
    | {
        type: "fragment";
        value: Image_image$key & { id: string };
      }
    | { type: "url"; value: string }
  )[];
  size?: number;
}) => {
  const firstImage = props.images.length > 0 ? props.images[0] : null;
  const layout = useLayoutContext();
  const size = props.size ?? layout.circle.smallMedium;

  const renderImage = useCallback(
    (
      image:
        | {
            type: "fragment";
            value: Image_image$key & { id: string };
          }
        | { type: "url"; value: string }
    ) => {
      return image.type === "fragment" ? (
        <Img
          type="remote"
          id={image.value.id}
          image={image.value}
          style={{ flex: 1 }}
        />
      ) : (
        <Image
          key={image.value}
          recyclingKey={image.value}
          source={{ uri: image.value, height: size, width: size }}
          style={{ flex: 1, height: size, width: size }}
        />
      );
    },
    [size]
  );

  return firstImage ? (
    <Box
      style={{
        height: size,
        width: size,
        overflow: "hidden",
      }}
      color="surface"
      cornerRadius="medium"
    >
      {renderImage(firstImage)}
    </Box>
  ) : null;
};
